export const XiquMapInformation = {
  venue: "Xiqu",
  venueId: "227ba8d6-fc31-4c54-9690-c4a1659ee180",
  i18nVenue: "venue_xiqu_centre",
  venueName: "Xiqu Centre",
  venueName_zh: "戲曲中心",
  floorAlignment: [
    {
      lcMapId: "f62d202b-a164-4d58-b31b-dc07381ccafa",
      id: "290c29c1-4d9e-4f4c-97bf-1afb21f405ca",
      ordinal: -2,
      name: "B2",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/50beb999-6abd-47d1-960d-16d65aaf56ab/m0-1718337562396XOQOXU.png",
      pixInMeter: 19.397799726963633,
      center: { lat: 22.30216765875302, lng: 114.16723631100545 },
      angle: 356.1234534144261,
      scale: 51.55228702359372,
      corners: {
        tl: { lat: 22.30271961208479, lng: 114.1665529985258 },
        tr: { lat: 22.30280349838915, lng: 114.1678294698037 },
        br: { lat: 22.30161570542125, lng: 114.1679196234851 },
        bl: { lat: 22.30153181911689, lng: 114.1666431522071 },
      },
      size: { width: 2560, height: 2560 },
      sizeInMeters: { width: 131.6500605703039, height: 132.4019818772277 },
    },
    {
      lcMapId: "f962dfb5-895c-4686-b116-f1bd907a0c5f",
      id: "358cc741-d7ac-4ac0-9e4f-e7811981a9c3",
      ordinal: -1,
      name: "LG",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/50beb999-6abd-47d1-960d-16d65aaf56ab/m1-1718337772350ZUCUBE.png",
      pixInMeter: 19.397799726963633,
      center: { lat: 22.30216765875302, lng: 114.16723631100545 },
      angle: 356.1234534144261,
      scale: 51.55228702359372,
      corners: {
        tl: { lat: 22.30271961208479, lng: 114.1665529985258 },
        tr: { lat: 22.30280349838915, lng: 114.1678294698037 },
        br: { lat: 22.30161570542125, lng: 114.1679196234851 },
        bl: { lat: 22.30153181911689, lng: 114.1666431522071 },
      },
      size: { width: 2560, height: 2560 },
      sizeInMeters: { width: 131.6500605703039, height: 132.4019818772277 },
    },
    {
      lcMapId: "7210b906-564b-4c8a-ab2c-bd88287ccb41",
      id: "3f5d85b2-51a0-45d0-b0ad-94f978536547",
      ordinal: 0,
      name: "L0",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/50beb999-6abd-47d1-960d-16d65aaf56ab/m2-1718339315327ZERALU.png",
      pixInMeter: 19.397799726963633,
      center: { lat: 22.30216765875302, lng: 114.16723631100545 },
      angle: 356.1234534144261,
      scale: 51.55228702359372,
      corners: {
        tl: { lat: 22.30271961208479, lng: 114.1665529985258 },
        tr: { lat: 22.30280349838915, lng: 114.1678294698037 },
        br: { lat: 22.30161570542125, lng: 114.1679196234851 },
        bl: { lat: 22.30153181911689, lng: 114.1666431522071 },
      },
      size: { width: 2560, height: 2560 },
      sizeInMeters: { width: 131.6500605703039, height: 132.4019818772277 },
    },
    {
      lcMapId: "4a807e61-33a0-47dd-acb9-c7a017c71565",
      id: "427930dd-b061-4236-b4b7-67c34edbd87e",
      ordinal: 1,
      name: "L1",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/50beb999-6abd-47d1-960d-16d65aaf56ab/m3-1718339401022KEQAYU.png",
      pixInMeter: 19.397799726963633,
      center: { lat: 22.30216765875302, lng: 114.16723631100545 },
      angle: 356.1234534144261,
      scale: 51.55228702359372,
      corners: {
        tl: { lat: 22.30271961208479, lng: 114.1665529985258 },
        tr: { lat: 22.30280349838915, lng: 114.1678294698037 },
        br: { lat: 22.30161570542125, lng: 114.1679196234851 },
        bl: { lat: 22.30153181911689, lng: 114.1666431522071 },
      },
      size: { width: 2560, height: 2560 },
      sizeInMeters: { width: 131.6500605703039, height: 132.4019818772277 },
    },
    {
      lcMapId: "cfa25079-2ef4-4862-bfe6-7450cf3fcd73",
      id: "6926d008-6d45-4fe6-b54e-34c1693310bc",
      ordinal: 2,
      name: "L2",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/50beb999-6abd-47d1-960d-16d65aaf56ab/m4-1718339548363DIZIVA.png",
      pixInMeter: 19.397799726963633,
      center: { lat: 22.30216765875302, lng: 114.16723631100545 },
      angle: 356.1234534144261,
      scale: 51.55228702359372,
      corners: {
        tl: { lat: 22.30271961208479, lng: 114.1665529985258 },
        tr: { lat: 22.30280349838915, lng: 114.1678294698037 },
        br: { lat: 22.30161570542125, lng: 114.1679196234851 },
        bl: { lat: 22.30153181911689, lng: 114.1666431522071 },
      },
      size: { width: 2560, height: 2560 },
      sizeInMeters: { width: 131.6500605703039, height: 132.4019818772277 },
    },
    {
      lcMapId: "45180438-4508-4d52-9773-3f1129325152",
      id: "XIQU_TBC_3",
      ordinal: 3,
      name: "L3",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/50beb999-6abd-47d1-960d-16d65aaf56ab/m5-1718339627764YALUCA.png",
      pixInMeter: 19.397799726963633,
      center: { lat: 22.30216765875302, lng: 114.16723631100545 },
      angle: 356.1234534144261,
      scale: 51.55228702359372,
      corners: {
        tl: { lat: 22.30271961208479, lng: 114.1665529985258 },
        tr: { lat: 22.30280349838915, lng: 114.1678294698037 },
        br: { lat: 22.30161570542125, lng: 114.1679196234851 },
        bl: { lat: 22.30153181911689, lng: 114.1666431522071 },
      },
      size: { width: 2560, height: 2560 },
      sizeInMeters: { width: 131.6500605703039, height: 132.4019818772277 },
    },
    {
      lcMapId: "7a53b663-abc0-4694-bf10-091a71da201e",
      id: "XIQU_TBC_4",
      ordinal: 4,
      name: "L4",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/50beb999-6abd-47d1-960d-16d65aaf56ab/m6-1718339698625NUJIKU.png",
      pixInMeter: 19.397799726963633,
      center: { lat: 22.30216765875302, lng: 114.16723631100545 },
      angle: 356.1234534144261,
      scale: 51.55228702359372,
      corners: {
        tl: { lat: 22.30271961208479, lng: 114.1665529985258 },
        tr: { lat: 22.30280349838915, lng: 114.1678294698037 },
        br: { lat: 22.30161570542125, lng: 114.1679196234851 },
        bl: { lat: 22.30153181911689, lng: 114.1666431522071 },
      },
      size: { width: 2560, height: 2560 },
      sizeInMeters: { width: 131.6500605703039, height: 132.4019818772277 },
    },
    {
      lcMapId: "bee64fd6-084e-47c2-809f-729d8113cc75",
      id: "XIQU_TBC_5",
      ordinal: 5,
      name: "L5",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/50beb999-6abd-47d1-960d-16d65aaf56ab/m7-1718339738641WESENI.png",
      pixInMeter: 19.397799726963633,
      center: { lat: 22.30216765875302, lng: 114.16723631100545 },
      angle: 356.1234534144261,
      scale: 51.55228702359372,
      corners: {
        tl: { lat: 22.30271961208479, lng: 114.1665529985258 },
        tr: { lat: 22.30280349838915, lng: 114.1678294698037 },
        br: { lat: 22.30161570542125, lng: 114.1679196234851 },
        bl: { lat: 22.30153181911689, lng: 114.1666431522071 },
      },
      size: { width: 2560, height: 2560 },
      sizeInMeters: { width: 131.6500605703039, height: 132.4019818772277 },
    },
  ],
  modelConfig: {
    folderPath: "venue/xiqu/",
    defaultPosition: [-1383, 0, -1415],
    defaultTarget: [-1380.42, 0, -1419.28],
    defaultFloorIndex: 0,
    defaultLcMapId: "7210b906-564b-4c8a-ab2c-bd88287ccb41",
    topAltitude: 600,
    downSpeed: 200,
    scaleFactor: 29.0966722643,
    moveSpeed: 2,
    rotateSpeed: 20,
    splat: {
      mode: "singleLod",
      singleLod: "lod/lod-meta.json",
    },
    floor: [
      {
        lcMapId: "f62d202b-a164-4d58-b31b-dc07381ccafa",
        id: "290c29c1-4d9e-4f4c-97bf-1afb21f405ca",
        index: -2,
        name: "B2",
        shortName: "B2",
        // sog: "b2/xiqu_b2_20260119_1630.sog",
        altitude: -185,
        topViewModel: "b2/B2_topView_20260612_0900_16tiles.glb",
        yAxis: -185,
        cameras: [
          [-1983.269, -203.1517, 977.2491],
          [-1984.88, -196.5339, 531.597],
          [-2166.221, -196.5, 748.2565],
        ],
        defaultPosition: [-2015.82, -185, -967.19],
        defaultTarget: [-2018.13, -185, -962.77],
      },
      {
        lcMapId: "f962dfb5-895c-4686-b116-f1bd907a0c5f",
        id: "358cc741-d7ac-4ac0-9e4f-e7811981a9c3",
        index: -1,
        name: "LG",
        shortName: "LG",
        // sog: "lg/xiqu_lg_20260119_1630.sog",
        altitude: -55,
        topViewModel: "lg/LG_topView_20260612_0900_16tiles.glb",
        yAxis: -55,
        cameras: [
          [-1950.242, -51.84412, 829.118],
          [-1692.008, -43.31032, 1957.18],
          [-1929.422, -28.37321, 1407.86],
          [-1793.617, -32.18947, 1133.987],
          [-1662.391, -32.18947, 1038.885],
          [-1923.973, -36.09593, 1355.136],
          [-1492.856, -2.235001, 1852.17],
        ],
        defaultPosition: [-1499.02, -55, -1921.24],
        defaultTarget: [-1494.83, -55, -1918.52],
      },
      {
        lcMapId: "7210b906-564b-4c8a-ab2c-bd88287ccb41",
        id: "3f5d85b2-51a0-45d0-b0ad-94f978536547",
        index: 0,
        name: "L0",
        shortName: "L0",
        // sog: "l0/xiqu_l0_20260119_1630.sog",
        altitude: 0,
        topViewModel: "l0/L0_topView_20260612_0900_16tiles.glb",
        yAxis: 0,
        cameras: [[-1496.303, 64.14569, 1594.011]],
        defaultPosition: [-1383, 0, -1415],
        defaultTarget: [-1380.42, 0, -1419.28],
      },
      {
        lcMapId: "4a807e61-33a0-47dd-acb9-c7a017c71565",
        id: "427930dd-b061-4236-b4b7-67c34edbd87e",
        index: 1,
        name: "L1",
        shortName: "L1",
        // sog: "l1/xiqu_l1_20260119_1630.sog",
        altitude: 110,
        topViewModel: "l1/L1_topView_20260612_0900_16tiles.glb",
        yAxis: 110,
        cameras: [
          [-1088.505, 114.4794, 1794.438],
          [-1349.384, 142.89, 1359.756],
          [-1792.78, 102.12, 1611.272],
        ],
        defaultPosition: [-1068.17, 110, -1292.06],
        defaultTarget: [-1071.36, 110, -1288.21],
      },
      {
        lcMapId: "cfa25079-2ef4-4862-bfe6-7450cf3fcd73",
        id: "6926d008-6d45-4fe6-b54e-34c1693310bc",
        index: 2,
        name: "L2",
        shortName: "L2",
        // sog: "l2/xiqu_l2_20260119_1630.sog",
        altitude: 230,
        topViewModel: "l2/L2_topView_20260612_0900_16tiles.glb",
        yAxis: 230,
        cameras: [
          [-1187.912, 255.7549, 1942.846],
          [-1274.9, 214.845, 1553.807],
          [-475.7089, 269.79, 1831.552],
          [-1711.162, 216.33, 1529.863],
        ],
        defaultPosition: [-1165.81, 230, -1796.63],
        defaultTarget: [-1161.1, 230, -1798.3],
      },
    ],
  },
};
